export const paths = {
    index: '/',
    auth: {
        appAuth: {
            login: '/auth/appAuth/login',
        },
    },
    changePassword:"/changePassword",
    callCenter: {
        index: '/call-center',
        create: '/call-center/create',
        edit: '/call-center/:caseID/edit',
    },
    crm: {
        index: '/crm',
        form: '/crm/:caseID/form',
    },
    chat: {
        index: '/chat',
    },
    supervisor: {
        index: '/supervisor',
        create: '/supervisor/create',
        approval: '/supervisor/:caseID/approval',
    },
    ossSupervisor: {
        index: '/ossSupervisor',
        create: '/ossSupervisor/create',
        approval: '/ossSupervisor/:caseID/approval',
    },
    monitor: {
        index: '/monitor',
    },
    report: {
        index: '/report',
        summaryReport: '/report/summary',
        surveyorReport: '/report/surveyor',
        claimReport: '/report/claim',
        enquiryReport: '/report/enquiry',
        closeClaimReport: '/report/closeClaim',
        monitor: '/report/monitor',
    },
    administrator: {
        index: '/administrator',
        user: '/administrator/user',
        outsource: '/administrator/outsource',
        outsourceZone: '/administrator/outsource-zone',
        company: '/administrator/company',
        role: '/administrator/role',

    },
    401: '/401',
    404: '/404',
    500: '/500'
};
